import { sample } from 'lodash';
import { createContext } from 'react';

const defaultContextValue = {
  product: {
    productId: '',
    vendorImage: '',
    vendorImages: [],
    articleName: null,
    articleCode: null,
    description: '',
    supplier: '',
    isCreateBarcode: true,
    createBatch: false,
    hsnCode: '',
    tags: [],
 metrics: {
  weight: 0,
  thickness: 0,
  length: 0,
  width: 0,
  inches: 0,
  centimeter: 0,
  meter: 0,
  meterPerKg: 0, 
},
    otherInformation: {
      skuPrefix: '',
      coneWeight: '',
      unitOfMeasures: {
        type: 'UOM',
        isRoll: true,
        isKg: false,
        isMeter: false,
        isYard: false,
      },
    },
    vendorProductInfo:{
      draftProductId: '',
      commission: ''    ,
      commissionPercentage: '',
      vendorId: '',
      productId: '',
      costPrice: '',
      ussId:'',
      vendorProductName: '',
      vendorProductId: '',
      swatchAvailable: false,
      sampleAvailable: false,
      swatchSent: '',
      swatchReceived: '',
      vendorProductImage: '',
      coneWeight: '',
      priceInclConeWeight: '',
    },
    totalProductPercent:'',
    prodVariants: {},
    productVariants: [],
    productCategories: {},  
    newProductVariants: [],
    fabricContent: {
      value: '',
      composition: {},
    },
    vendorProductName: '',
    vendorProductCode: '',
    totalProductPercent: '',
    priceSetting: {
      isMarkUp: false,
      isMarkDown: false,
      costPrice: 0,
      markUpPercent: 0,
      markDownPercent: 0,
      sellingPrice: 0,
      mrp: 0,
      margin: 0,
    },
    categoryId: '',
    gstId: '',
    brandId: '',
    seasonId: '',
    status: 'ACTIVE',
  },
  handleChange: () => {},
  addProduct: async () => {},
  setProduct: () => {},
  imageFile: null,
  setImageFile: () => {},
  inputError: {},
  setInputError: () => {},
  setHasMultiSelectCategoryMandatory: () => {},
};

export const ProductContext = createContext(defaultContextValue);